module.exports = __webpack_public_path__ + "img/06.45995a29.gif";